export default {"src":"/_next/static/media/discord-icon.55644417.svg","height":46,"width":51,"blurWidth":0,"blurHeight":0};